import { ActivitiesService } from '@/scripts/services/activities/activities-service';
import { helpers } from '@/scripts/helpers';
import { api } from '@/scripts/api';

export const activitiesTab = {
    state: () => ({
        isActivitiesLoading: false,
        activities: [],
        areAllActivitiesFetched: true,
        pageSize: 9,
        pagesSkipped: 0,
        activityUserFilterValue: null,
        activeActivityFilters: [],
        activeActivityUserFilter: [],
        activeActivityTypeFilter: [],
        activitySearch: '',
        loadActivitiesController: new AbortController(),
    }),

    getters: {
        skippedRecords(state) {
            return state.pageSize * state.pagesSkipped;
        },
    },

    actions: {
        updateActivityUserFilterValue({ state, dispatch }, user) {
            state.activityUserFilterValue = { name: '', id: '' };
            const newUser = { name: user.name, key: user.id };
            const isInActiveFilters = state.activeActivityFilters.find(
                ({ key }) => key === newUser.key
            );
            if (!isInActiveFilters) {
                state.activeActivityFilters.push(newUser);
                state.activeActivityUserFilter.push(newUser);

                dispatch('loadActivities');
            }
        },

        updateActivitySearch({ state, dispatch }, search) {
            if (state.activitySearch !== search) {
                state.activitySearch = search;

                dispatch('loadActivities');
            }
        },

        updateActivityType({ state, dispatch }, activityType) {
            const newTypeFilter = {
                name: activityType.name,
                key: activityType.name,
                type: 'activity-type'
            };
            const isInActiveFilters = state.activeActivityFilters.find(
                ({ key }) => key === newTypeFilter.key
            );

            if (!isInActiveFilters) {
                state.activeActivityFilters = state.activeActivityFilters.filter(
                    ({ type }) => type !== 'activity-type'
                );
                state.activeActivityFilters.push(newTypeFilter);
                state.activeActivityTypeFilter = [activityType];

                dispatch('loadActivities');
            }
        },

        removeActivityFilter({ state, dispatch }, filter) {
            state.activeActivityFilters = state.activeActivityFilters.filter(
                ({ name, key }) => name !== filter.name && key !== filter.key
            );
            state.activeActivityUserFilter = state.activeActivityUserFilter.filter(
                ({ name, key }) => name !== filter.name && key !== filter.key
            );
            state.activeActivityTypeFilter = [];

            return dispatch('loadActivities');
        },

        clearAllActivityFilters({ state, dispatch }) {
            const needsRefresh = state.activeActivityFilters.length > 0
                || state.activeActivityUserFilter.length > 0
                || state.activeActivityTypeFilter.length > 0;

            if (needsRefresh) {
                state.activeActivityFilters = [];
                state.activeActivityUserFilter = [];
                state.activeActivityTypeFilter = [];

                dispatch('loadActivities');
            }
        },

        showMoreAssignedRecords({ state, dispatch }) {
            const activities = [...state.activities];

            state.pagesSkipped++;
            return dispatch('loadActivities')
                .then(({ groups }) => {
                    activities.push(...groups);
                    state.activities = activities;
                });
        },

        refreshActivities({ state, dispatch }) {
            state.pagesSkipped = 0;
            state.activities = [];
            state.areAllActivitiesFetched = false;

            return dispatch('loadActivities');
        },

        loadActivities({ state, rootState, getters }) {
            const dealId = rootState.opportunity.id;
            const pageSize = state.pageSize;
            const type = state.activeActivityTypeFilter[0] ? state.activeActivityTypeFilter[0].name : 'All';
            const search = state.activitySearch;
            const userFilter = state.activeActivityUserFilter;
            const skippedRecords = getters.skippedRecords;

            state.loadActivitiesController.abort();
            state.loadActivitiesController = new AbortController();

            state.isActivitiesLoading = true;

            return ActivitiesService.getActivities({
                dealId,
                pageSize,
                type,
                search,
                userFilter,
                skippedRecords
            }, state.loadActivitiesController.signal)
                .then(({ response, groups }) => {
                    state.areAllActivitiesFetched = response.data.value.length < state.pageSize;
                    state.activities = [...groups];

                    return { response, groups };
                })
                .catch((error) => {
                    if (!api.isCanceled(error)) {
                        helpers.showFailNotification(
                            'An error occurred while fetching your activities.',
                            { error }
                        );
                    }

                })
                .finally((() => {
                    state.isActivitiesLoading = false;
                }));
        }
    }
};